import React from 'react';
import { Phone, CheckCircle, DollarSign, Clock } from 'lucide-react';
export function FleetMaintenancePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6222">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6223">
        <div className="container mx-auto px-4" data-id="element-6224">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6225">
            Maximize Your Up Time and Minimize Repair Costs
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6226">
            Professional Fleet Maintenance and Repair
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6227">
        <div className="max-w-4xl mx-auto" data-id="element-6228">
          {/* Hero Image */}
          <div className="mb-8" data-id="element-6229">
            <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/preview/uploaded/images/towing.jpg?opt=w3" alt="Fleet maintenance and towing services" className="w-full h-auto rounded-lg shadow-md" data-id="element-6230" />
          </div>

          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6231">
            <p className="text-lg text-gray-700 mb-6" data-id="element-6232">
              <strong data-id="element-6233">
                The staff at Garrett Auto & Truck Service knows how important
                your time is
              </strong>
              , and how difficult it can be to stay on top of maintenance
              schedules when you are busy running your business.
            </p>

            <p className="text-lg text-gray-700" data-id="element-6234">
              We offer a Fleet Maintenance Program that takes all the hassle of
              keeping your fleet up and running off your plate – whether you
              have one truck or fifty. We'll design, implement and administer
              maintenance and repair program for your entire fleet, helping you
              keep breakdowns and hassle to a minimum.
            </p>
          </div>

          {/* Cost Comparison */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6235">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6236">
              Real Cost Comparison
            </h2>

            <p className="text-lg text-gray-700 mb-6 text-center" data-id="element-6237">
              Let's look at the costs for complete maintenance (oil change, oil
              filter, chassis lube & safety inspection) for a 2004 Ford F600/800
              with a 5.9 liter Cummins engine:
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-6238">
              {/* Dealer Cost */}
              <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6" data-id="element-6239">
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-6240">
                  Truck/Engine Dealer Shop
                </h3>

                <div className="text-center mb-4" data-id="element-6241">
                  <div className="text-4xl font-bold text-red-600 mb-2" data-id="element-6242">
                    $365.13
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-6243">Base Service Cost</p>
                </div>

                <div className="space-y-3 text-gray-700" data-id="element-6244">
                  <div className="flex items-start" data-id="element-6245">
                    <span className="text-red-600 mr-2 flex-shrink-0 mt-1" data-id="element-6246">
                      ✗
                    </span>
                    <span data-id="element-6247">Lost man-hours while driver waits</span>
                  </div>
                  <div className="flex items-start" data-id="element-6248">
                    <span className="text-red-600 mr-2 flex-shrink-0 mt-1" data-id="element-6249">
                      ✗
                    </span>
                    <span data-id="element-6250">Time and hassle handling paperwork</span>
                  </div>
                  <div className="flex items-start" data-id="element-6251">
                    <span className="text-red-600 mr-2 flex-shrink-0 mt-1" data-id="element-6252">
                      ✗
                    </span>
                    <span data-id="element-6253">Keeping track of schedule yourself</span>
                  </div>
                  <div className="flex items-start" data-id="element-6254">
                    <span className="text-red-600 mr-2 flex-shrink-0 mt-1" data-id="element-6255">
                      ✗
                    </span>
                    <span data-id="element-6256">Higher overhead costs</span>
                  </div>
                </div>
              </div>

              {/* Garrett Auto Cost */}
              <div className="bg-green-50 border-2 border-green-500 rounded-lg p-6 relative" data-id="element-6257">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-green-600 text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-6258">
                  BEST VALUE
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-6259">
                  Garrett Auto & Truck
                </h3>

                <div className="text-center mb-4" data-id="element-6260">
                  <div className="text-4xl font-bold text-green-600 mb-2" data-id="element-6261">
                    $265.11
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-6262">
                    Complete Service Package
                  </p>
                </div>

                <div className="space-y-3 text-gray-700" data-id="element-6263">
                  <div className="flex items-start" data-id="element-6264">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6265" />
                    <span data-id="element-6266">Convenient scheduling options</span>
                  </div>
                  <div className="flex items-start" data-id="element-6267">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6268" />
                    <span data-id="element-6269">Minimize downtime</span>
                  </div>
                  <div className="flex items-start" data-id="element-6270">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6271" />
                    <span data-id="element-6272">We handle all paperwork</span>
                  </div>
                  <div className="flex items-start" data-id="element-6273">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6274" />
                    <span data-id="element-6275">We track your maintenance schedule</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Savings Highlight */}
            <div className="mt-8 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg p-6 text-center" data-id="element-6276">
              <div className="flex items-center justify-center mb-2" data-id="element-6277">
                <DollarSign size={32} className="mr-2" data-id="element-6278" />
                <span className="text-3xl font-bold" data-id="element-6279">
                  Save $100.02 Per Service
                </span>
              </div>
              <p className="text-green-100 text-lg" data-id="element-6280">
                Plus eliminate lost productivity and administrative hassle
              </p>
            </div>
          </div>

          {/* Benefits Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6281">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6282">
              Why Choose Garrett Auto & Truck?
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-6283">
              <div className="text-center" data-id="element-6284">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6285">
                  <DollarSign className="text-blue-600" size={32} data-id="element-6286" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6287">
                  Lower Costs
                </h3>
                <p className="text-gray-700" data-id="element-6288">
                  Save over $100 per service compared to dealer prices
                </p>
              </div>

              <div className="text-center" data-id="element-6289">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6290">
                  <Clock className="text-green-600" size={32} data-id="element-6291" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6292">
                  Save Time
                </h3>
                <p className="text-gray-700" data-id="element-6293">
                  Convenient scheduling means minimal disruption to your
                  operations
                </p>
              </div>

              <div className="text-center" data-id="element-6294">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6295">
                  <CheckCircle className="text-purple-600" size={32} data-id="element-6296" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6297">
                  Full Service
                </h3>
                <p className="text-gray-700" data-id="element-6298">
                  We handle scheduling, paperwork, and maintenance tracking
                </p>
              </div>
            </div>
          </div>

          {/* Fleet Size Options */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6299">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6300">
              Fleet Maintenance for Any Size Operation
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-6301">
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-6302">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6303">
                  Small Fleets (1-5 Vehicles)
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-6304">
                  <li className="flex items-start" data-id="element-6305">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6306" />
                    <span data-id="element-6307">Personalized service and attention</span>
                  </li>
                  <li className="flex items-start" data-id="element-6308">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6309" />
                    <span data-id="element-6310">Flexible scheduling around your needs</span>
                  </li>
                  <li className="flex items-start" data-id="element-6311">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6312" />
                    <span data-id="element-6313">Direct communication with technicians</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-lg p-6" data-id="element-6314">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6315">
                  Large Fleets (5+ Vehicles)
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-6316">
                  <li className="flex items-start" data-id="element-6317">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6318" />
                    <span data-id="element-6319">Dedicated fleet coordinator</span>
                  </li>
                  <li className="flex items-start" data-id="element-6320">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6321" />
                    <span data-id="element-6322">Volume pricing and discounts</span>
                  </li>
                  <li className="flex items-start" data-id="element-6323">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6324" />
                    <span data-id="element-6325">Comprehensive reporting and analytics</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6326">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6327">
              Start Saving on Fleet Maintenance Today
            </h2>
            <p className="text-xl mb-6" data-id="element-6328">
              Get a custom fleet maintenance plan designed for your business
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6329">
              <Phone className="mr-3" size={24} data-id="element-6330" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6331">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}